import { useEffect } from "react";

type ShortcutHandler = (e: KeyboardEvent) => void;

export default function useKeyboardShortcut(
    keys: string[] | string,
    callback: ShortcutHandler,
    options?: { preventDefault?: boolean },
) {
    useEffect(() => {
        const keysArray = Array.isArray(keys) ? keys : [keys];

        const handleKeyDown = (e: KeyboardEvent) => {
            // Prevent triggering keyboard shortcuts in inputs
            const tag = (e.target as HTMLElement)?.tagName?.toLowerCase();
            const isTyping = tag === "input" || tag === "textarea" || (e.target as HTMLElement)?.isContentEditable;

            if (isTyping) return;

            if (keysArray.includes(e.key) || keysArray.includes(e.code)) {
                if (options?.preventDefault) {
                    e.preventDefault();
                }
                callback(e);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [keys, callback, options?.preventDefault]);
}
